import React from "react";
import { SoudniSporVO, StavSporuBarvaEnum } from "../api";
import { Icon, Space, Tag, TagIntent, Text, Title } from "@mc/ui-v4";
import { faPaperclip, faCircle } from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "@mc/react-format";
import { formatSubjekt } from "../utils";
type Props = {
  soudniSpor: SoudniSporVO;
};
const getStavColor = (stav: StavSporuBarvaEnum): TagIntent => {
  switch (stav) {
    case StavSporuBarvaEnum.USPECH:
      return "success";
      return "warning";
    case StavSporuBarvaEnum.NEUSPECH:
      return "danger";
    default:
      return "default";
  }
};
export const SoudniSpisSeznamItem: React.FC<Props> = ({ soudniSpor }) => {
  return (
    <div className={"d-flex"}>
      <Space size={"1"} vertical className={" w-100"}>
        <div className={"d-flex w-100"}>
          <Title level={2}>
            {soudniSpor?.subjektNazev}{" "}
            <Text size={"normal"}>
              {formatSubjekt(
                soudniSpor.subjektAdresa.popisAdresa,
                soudniSpor.subjektIc,
                soudniSpor.subjektDatumNarozeni
              )}
            </Text>
          </Title>
        </div>
        <div>
          <Space size={"1"}>
            <Tag intent={"secondary"}>
              {soudniSpor.nazevTypPripad ? soudniSpor.nazevTypPripad : "-"}
            </Tag>
            <Tag intent={"secondary"}>
              {soudniSpor.nazevDruhPripad ? soudniSpor.nazevDruhPripad : "-"}
            </Tag>
          </Space>
        </div>
        <Text intent={"secondary"}>{`${
          soudniSpor.identifikaceKauzy ? soudniSpor.identifikaceKauzy : "-"
        } / ${
          soudniSpor.oznaceniPripadu ? soudniSpor.oznaceniPripadu : "-"
        }`}</Text>
      </Space>
      <Space size={"1"} vertical className={"w-100 d-flex align-items-end"}>
        <div style={{ height: "fit-content" }}>
          <Tag intent={getStavColor(soudniSpor.stavSporuBarva)}>{`${
            soudniSpor.stavSporu ? soudniSpor.stavSporu : "-"
          } / ${
            soudniSpor.vysledekSporu ? soudniSpor.vysledekSporu : "-"
          }`}</Tag>
        </div>
        <div>
          <Title level={3} intent={"primary"}>
            {soudniSpor.pocetDokumentu} <Icon icon={faPaperclip} />
          </Title>
        </div>
        <div>
          <Text intent={"secondary"}>{`${soudniSpor.rok} . ${
            soudniSpor.externiZastoupeni
              ? "Externí zasoutepní"
              : "Vlastní zastoupení"
          } . ${soudniSpor.ojVlastnika}`}</Text>
        </div>
      </Space>
    </div>
  );
};
